<div class="refund-result">
  <p class="refund-result__message">{{ cancellationMessage }}</p>

  <p
    *ngIf="isRefundProcessing"
    class="refund-result__message refund-result__message--processing"
  >
    {{ refundProcessingMessage }}
  </p>

  <p
    *ngIf="showRefundResultMessage"
    class="refund-result__message"
    [class.refund-result__message--warning]="!response.refund"
    [class.refund-result__message--success]="response.refund"
  >
    {{ refundMessage }}
  </p>

  <span class="buttons">
    <p-button
      *ngIf="hasNewOrder"
      label="Ver nova order"
      severity="primary"
      (onClick)="goToNewOrder()"
    />
    <p-button label="Fechar" severity="secondary" (onClick)="close()" />
  </span>
</div>
